module.exports = __webpack_public_path__ + "img/avalara.e25c4c40.png";